/* tslint:disabled */
/**
 *
 * @export
 * @interface DismissAlertPayload
 */
export interface DismissAlertPayload {
  /**
   *
   * @type {boolean}
   * @memberof DismissAlertPayload
   */
  value: boolean
}

export function DismissAlertPayloadFromJSON(json: any): DismissAlertPayload {
  return {
    value: json['value']
  }
}

export function DismissAlertPayloadToJSON(value?: DismissAlertPayload): any {
  if (value === undefined) {
    return undefined
  }
  return {
    value: value.value
  }
}
